import {AppSettings} from './app.settings';
export class LocationSettings{
    public static ALL_LOCATIONS = `${AppSettings.BASE_URL}/api/location/all`;
    public static SEARCH_LOCATIONS = `${AppSettings.BASE_URL}/api/location`;
    public static TOP_LOCATIONS = `${AppSettings.BASE_URL}/api/location/top`;
}